import Form_5 from './Form_5-redux';

export default Form_5;
